import React from "react";
import { Stack } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

export const ActionButtonsSkeleton: React.FC = () => {
    return (
        <Stack gap={2} direction="horizontal" className="mb-3">
            <Skeleton width="6rem" height="38px" />
            <Skeleton width="6rem" height="38px" />
            <Skeleton width="6rem" height="38px" />
        </Stack>
    );
};
